import type { NavigationMapInfo } from './api/navigation';

/** World coordinates → SVG/image pixel coordinates (matches SVG viewBox). */
export function worldToPx(info: NavigationMapInfo, p: { x: number; y: number }) {
  return {
    x: (p.x - info.origin[0]) / info.resolution,
    y: info.height - (p.y - info.origin[1]) / info.resolution,
  };
}

/** SVG/image pixel coordinates → world coordinates. */
export function pxToWorld(info: NavigationMapInfo, px: number, py: number) {
  return {
    x: info.origin[0] + px * info.resolution,
    y: info.origin[1] + (info.height - py) * info.resolution,
  };
}
